import React from 'react'
import styled from 'styled-components'

import { color as globalColor } from '../globalStyles'

const Spinner = styled.div`
  box-sizing: border-box;
  height: 40px;
  width: 40px;
  top: calc(-10px * 2 / 3);

  * {
    box-sizing: border-box;
  }

  .square {
    height: 10px;
    width: 10px;
    top: calc(-10px * 2 / 3);
    margin-right: calc(10px / 3);
    margin-top: calc(10px / 3);
    background: ${props => props.color};
    float: left;
    position: relative;
    opacity: 0;
    animation: self-building-square-spinner 3s infinite;
  }

  .square:nth-child(1) {
    animation-delay: calc(150ms * 6);
  }

  .square:nth-child(2) {
    animation-delay: calc(150ms * 7);
  }

  .square:nth-child(3) {
    animation-delay: calc(150ms * 8);
  }

  .square:nth-child(4) {
    animation-delay: calc(150ms * 3);
  }

  .square:nth-child(5) {
    animation-delay: calc(150ms * 4);
  }

  .square:nth-child(6) {
    animation-delay: calc(150ms * 5);
  }

  .square:nth-child(7) {
    animation-delay: calc(150ms * 0);
  }

  .square:nth-child(8) {
    animation-delay: calc(150ms * 1);
  }

  .square:nth-child(9) {
    animation-delay: calc(150ms * 2);
  }

  .clear {
    clear: both;
  }

  @keyframes self-building-square-spinner {
    0% {
      opacity: 0;
    }
    5% {
      opacity: 1;
      top: 0;
    }
    50.9% {
      opacity: 1;
      top: 0;
    }
    55.9% {
      opacity: 0;
      top: inherit;
    }
  }
`

export default ({ className = '', color = globalColor.midGrey, ...props }) => (
  <Spinner
    className={`Spinner self-building-square-spinner ${className}`}
    color={color}
    {...props}
  >
    <div className='square' />
    <div className='square' />
    <div className='square' />
    <div className='square clear' />
    <div className='square' />
    <div className='square' />
    <div className='square clear' />
    <div className='square' />
    <div className='square' />
  </Spinner>
)



// WEBPACK FOOTER //
// ./src/components/Spinner.js